import createAction from '../utils/createAction'
import * as ActionTypes from '../constants/ActionTypes'

export const dataFetch = () => createAction(ActionTypes.DATA_FETCH)

export const dataSuccess = data =>
  createAction(ActionTypes.DATA_SUCCESS, {
    data,
  })
